// Bolster AI Design System Color Palette
// Use these constants throughout all chart and component implementations

export const BOLSTER_COLORS = {
  // Primary colors
  PRIMARY: '#3b82f6',      // Blue - primary actions, highlights
  WARNING: '#fbbf24',      // Yellow - warnings, alerts
  DANGER: '#ef4444',       // Red - errors, danger states
  SUCCESS: '#22c55e',      // Green - success, positive states

  // Text colors
  TEXT_PRIMARY: '#18181a',    // Primary text
  TEXT_SECONDARY: '#6b7280',  // Secondary text
  TEXT_MUTED: '#9ca3af',      // Muted text

  // Background colors
  BG_WHITE: '#ffffff',        // White background (cards)
  BG_SUBTLE: '#fafafa',       // Subtle background
  BG_HOVER: '#f3f4f6',        // Hover states
  BG_MAIN: '#f9fafb',         // Main page background

  // Border colors
  BORDER: '#e5e7eb',          // Standard borders
  BORDER_LIGHT: '#f3f4f6',    // Light borders

  // Chart-specific color palettes
  CHART_PRIMARY: ['#3b82f6', '#60a5fa', '#93c5fd', '#bfdbfe', '#dbeafe'],
  CHART_WARNING: ['#fbbf24', '#fcd34d', '#fde68a', '#fef3c7', '#fef9e7'],
  CHART_DANGER: ['#ef4444', '#f87171', '#fca5a5', '#fecaca', '#fee2e2'],
  CHART_SUCCESS: ['#22c55e', '#4ade80', '#86efac', '#bbf7d0', '#dcfce7'],

  // Multi-color palette for diverse datasets
  CHART_MULTI: [
    '#3b82f6',  // Blue
    '#22c55e',  // Green
    '#fbbf24',  // Yellow
    '#ef4444',  // Red
    '#8b5cf6',  // Purple (accent)
    '#06b6d4',  // Cyan
    '#f97316',  // Orange
    '#ec4899',  // Pink
  ],

  // Seasonal colors (for seasonal charts)
  SEASONAL: {
    SPRING: '#22c55e',   // Green
    SUMMER: '#fbbf24',   // Yellow
    FALL: '#ef4444',     // Red
    WINTER: '#3b82f6',   // Blue
  },

  // Gradient utilities
  GRADIENTS: {
    PRIMARY: 'linear-gradient(135deg, #3b82f6 0%, #60a5fa 100%)',
    WARNING: 'linear-gradient(135deg, #fbbf24 0%, #fcd34d 100%)',
    DANGER: 'linear-gradient(135deg, #ef4444 0%, #f87171 100%)',
    SUCCESS: 'linear-gradient(135deg, #22c55e 0%, #4ade80 100%)',
  },

  // Opacity variants (for transparency)
  withOpacity: (color, opacity) => {
    // Convert hex to rgba
    const r = parseInt(color.slice(1, 3), 16);
    const g = parseInt(color.slice(3, 5), 16);
    const b = parseInt(color.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  },
};

// Legacy color mappings (for backward compatibility during migration)
export const LEGACY_COLOR_MAP = {
  '#6366f1': BOLSTER_COLORS.PRIMARY,  // Indigo → Blue
  '#4f46e5': BOLSTER_COLORS.PRIMARY,  // Dark indigo → Blue
  '#8b5cf6': '#8b5cf6',               // Purple → Keep for accent
  '#fb923c': BOLSTER_COLORS.WARNING,  // Orange → Yellow
  '#f87171': BOLSTER_COLORS.DANGER,   // Light red → Red
  '#60a5fa': BOLSTER_COLORS.PRIMARY,  // Light blue → Primary blue
};

// BBC Style configuration adapted to Bolster AI
export const BOLSTER_CHART_STYLE = {
  FONT_FAMILY: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  MONO_FONT: "'JetBrains Mono', 'Consolas', monospace",
  TITLE_SIZE: '18px',
  SUBTITLE_SIZE: '14px',
  AXIS_SIZE: 11,
  PRIMARY_COLOR: BOLSTER_COLORS.PRIMARY,
  SECONDARY_COLOR: BOLSTER_COLORS.WARNING,
  HIGHLIGHT_COLOR: BOLSTER_COLORS.DANGER,
  POSITIVE_COLOR: BOLSTER_COLORS.SUCCESS,
  NEGATIVE_COLOR: BOLSTER_COLORS.DANGER,
  AXIS_COLOR: BOLSTER_COLORS.TEXT_MUTED,
  TEXT_COLOR: BOLSTER_COLORS.TEXT_PRIMARY,
  BORDER_COLOR: BOLSTER_COLORS.BORDER,
  MARGIN: { top: 60, right: 30, left: 20, bottom: 20 },
};

export default BOLSTER_COLORS;
